import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
// Explicit return types keep `tsc` from serializing the expanded PublicPost
// endpoint shape into `.d.ts` (TS7056 otherwise).
const finders = (rawClient) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/posts'),
    listByType: allpeepNoPayloadEndpoint(rawClient, '/posts/by-type/:type'),
    listByHashtag: allpeepNoPayloadEndpoint(rawClient, '/posts/by-hashtag/:hashtag'),
    listByGroup: allpeepNoPayloadEndpoint(rawClient, '/posts/by-group/:id'),
    listByProfile: allpeepNoPayloadEndpoint(rawClient, '/posts/by-profile/:id'),
    listBookmarks: allpeepNoPayloadEndpoint(rawClient, '/posts/bookmarks'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/posts/:id'),
    context: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/context'),
    reposts: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/reposts'),
    recordings: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/recordings'),
    publishRecordingReply: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/recordings/:recordingId/reply', 'post'),
    deleteRecording: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/recordings/:recordingId', 'delete'),
    unseenCounts: allpeepNoPayloadEndpoint(rawClient, '/posts/unseen/counts'),
});
const eventFeeds = (rawClient) => ({
    events: {
        my: {
            upcoming: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/my/upcoming'),
            current: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/my/current'),
            past: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/my/past'),
        },
        upcoming: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/upcoming'),
        current: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/current'),
        past: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/past'),
        group: {
            upcoming: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/by-group/:groupId/upcoming'),
            past: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/events/by-group/:groupId/past'),
        },
    },
});
const jamFeeds = (rawClient) => ({
    jams: {
        upcoming: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/jams/upcoming'),
        past: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/jams/past'),
        my: {
            upcoming: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/jams/my/upcoming'),
            past: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/jams/my/past'),
        },
    },
});
const postFeeds = (rawClient) => ({
    my: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/my'),
    local: allpeepNoPayloadEndpoint(rawClient, '/posts/feeds/local'),
});
const feeds = (rawClient) => ({
    feeds: Object.assign(Object.assign(Object.assign({}, postFeeds(rawClient)), eventFeeds(rawClient)), jamFeeds(rawClient)),
});
const mutators = (rawClient) => ({
    create: allpeepPayloadEndpoint(rawClient, '/posts'),
    update: allpeepPayloadEndpoint(rawClient, '/posts/:id', 'put'),
    delete: allpeepNoPayloadEndpoint(rawClient, '/posts/:id', 'delete'),
    react: allpeepPayloadEndpoint(rawClient, '/posts/:id/react'),
    retractReaction: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/react', 'delete'),
    bookmark: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/bookmark', 'post'),
    unbookmark: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/bookmark', 'delete'),
    seen: allpeepPayloadEndpoint(rawClient, '/posts/seen', 'post'),
    seenByGroup: allpeepNoPayloadEndpoint(rawClient, '/posts/seen/by-group/:groupId', 'post'),
    repost: allpeepNoPayloadEndpoint(rawClient, '/posts/:id/reposts', 'post'),
    vote: allpeepPayloadEndpoint(rawClient, '/posts/:id/vote'),
    rsvp: allpeepPayloadEndpoint(rawClient, '/posts/:id/rsvp', 'post'),
    rsvpManage: allpeepPayloadEndpoint(rawClient, '/posts/:id/rsvp/:profileId', 'post'),
});
export const posts = (rawClient) => (Object.assign(Object.assign(Object.assign({}, finders(rawClient)), mutators(rawClient)), feeds(rawClient)));
